import { render, staticRenderFns } from "./route_configuration.vue?vue&type=template&id=dc8ff07c&scoped=true"
import script from "./route_configuration.vue?vue&type=script&lang=js"
export * from "./route_configuration.vue?vue&type=script&lang=js"
import style0 from "./route_configuration.vue?vue&type=style&index=0&id=dc8ff07c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8ff07c",
  null
  
)

export default component.exports